import * as amplitude from "@amplitude/analytics-browser"
import { sendEventToOptimizely } from "./analytics-optimizely"
import getConsentsData from "./analytics-consents"
import setUserProperties from "./analytics-identify"

const amplitudeProperties = {
  "First name": "firstname",
  "Last name": "lastname",
  Email: "email",
  Company: "company",
  Phone: "phone",
  "Hubspot email opt in": "hs_web_email_opt_in",
}

export default async function analyticsFormSubmit(
  formId: string,
  data?: {
    redirectUrl?: string
    submissionValues: Record<string, string>
  },
) {
  const filteredFormData = Object.entries(amplitudeProperties).reduce(
    (acc: Record<string, string>, [key, value]) => {
      if (data?.submissionValues[value] !== undefined) {
        acc[key] = data.submissionValues[value]
      }
      return acc
    },
    {},
  )

  setUserProperties({ ...filteredFormData })
  sendEventToOptimizely("marketing_form_submitted", {
    "Form ID": formId,
    "Form provider": "hubspot",
  })

  await amplitude.track("Marketing Form Submitted", {
    ...filteredFormData,
    "Form ID": formId,
    "Form provider": "hubspot",
    ...getConsentsData(),
  }).promise
}
